(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["skip-links"]) return;
  try {
    
  $( document ).ready(function() {
    $( ".cchw-skip-links li a").unbind();
  });

  } catch(e) { console.error(e); }
})();
})();
